export default __webpack_public_path__ + "static/media/apple.474a9e6b.svg";